/**
 * Shows one random child story in the mega menu, re-picking each time the menu
 * item is opened so there's fresh content every visit. Picking on open (rather
 * than only on connect) also survives the theme's section-hydration morph, which
 * otherwise resets the server-rendered default.
 */
class CsRandomStory extends HTMLElement {
  connectedCallback() {
    this.pick();

    const item = this.closest('.cs-has-dd');
    if (item && !this.boundOpen) {
      this.boundOpen = true;
      const repick = () => this.pick();
      item.addEventListener('pointerenter', repick);
      item.addEventListener('focusin', repick);
    }
  }

  pick() {
    const stories = Array.from(this.querySelectorAll('.cs-dd__story'));
    if (stories.length <= 1) return;

    const chosen = Math.floor(Math.random() * stories.length);
    stories.forEach((story, i) => {
      story.hidden = i !== chosen;
    });
  }
}

if (!customElements.get('cs-random-story')) {
  customElements.define('cs-random-story', CsRandomStory);
}
